<template>

  <NavBar />

  <header class="relative">
    <img src="/images/golf.jpg" alt="Intro">
    <div class="absolute bottom-0 w-full text-center bt-1 px-12 py-6 bg-slate-900/40  font-semibold text-lime-100 text-xl">
      Areál je otevřen od dubna do září, pro rezervaci volejte <a href="tel:+420776 488 764">776 488 764</a>
    </div>
  </header>

  
  <main class="p-4 text-slate-800 prose container mx-auto">

    <section>
      <!-- <h1 class="text-5xl font-normal leading-normal mt-0 mb-2 text-slate-700">
        Golf i Fotbalgolf
      </h1> -->
      <p>Přijdte si se svými kamarády zahrát spolu fotbalgof, nebo si potrénujte golfový odpal včetně hry na greenu. 
      <br><br>
      Příjemná obsluha včetně dostupného malého občerstvení. Těšíme se na Vás.
      </p>
      
    </section>

    <section>
      <h1 id="golf" class="scroll-mt-6">Golf</h1>
      <p>Golfový areál v Doksech je svou náročností určen převážně začátečníkům, kteří si zde mohou vyzkoušet jak odpalování tak puttování. Zkušenější golfista zas jistě ocení klidné prostředí pro trénink krátké hry.</p>
    </section>

    <section>
      <h1 id="fotbalgolf" class="scroll-mt-6">FotbalGolf</h1>
      <p>
        Nově jsme otevřeli devítijamkové hřiště, je vhodné pro všechny typu hráčů, přijďte si vyzkoušet hru. Ideální pro větší týmy. Počet her není omezen.

      <br><br>

      </p>
    </section>

     <section>
      <h1 >Ceník</h1>
      <p>
        <!-- Naše ceny Vás překvapí, jde nám o zábavu. Poskytujeme skupinové slevy. -->
      <!-- <br><br> -->
      <table>
        <tr><td>
          <b>Golf</b>
          <ul>
            <li>Zapůjčení vybavení - 1x hůl 50,- Kč</li>
            <li>Míče na driving range (1 ks) 1,- Kč	</li>
          </ul>
          <b class="block mt-2">FotbalGolf</b>
          <ul>
            <li>Celodenní vstup	 - 100,- Kč</li>
          </ul>
          <b class="block mt-2">Firemní akce</b>
          <ul>
            <li>Pro detaily volejte <a href="tel:+420776 488 764">776 488 764</a></li>
          </ul>
        </td></tr>
      </table>
      </p>
    </section>
    
    <section>
      <h1 >O nás</h1>
      <p>Jsme golfoví nadšenci, kterým učaroval tento nádherný sport. Založili jsme proto občanské sdružení - golfový klub, jehož cílem je rozvoj golfové hry pro nejširší veřejnost.Celý golfový areál budujeme převážně svépomocí a tak se nám daří držet celkové pořizovací i provozní náklady na nízké úrovni. Z tohoto důvodu jsou naše členské vstupní poplatky na cenově dostupné výši. Věříme totiž, že golf je opravdu sport pro každého, v každém věku.Náš areál je určen především pro trénink krátké hry, kterou si můžete vyzkoušet na našem chipping a putting greenu, driving range a 6 jamkové akademii.U nás si zahrajete golf i bez tzv. “zelené karty”.Těšíme se na Vaši návštěvu.</p>
    </section>

    <section>
      <h1 id="kontakt" class="scroll-mt-24">Kde nás najdete</h1>
      <span>Všechny aktuální novinky najdete na našem Facebooku, nebo Instagramu.</span>

      <div class="h-64 w-full mt-2">
        <h4>Mapa</h4>
        <iframe style="border:none" src="https://en.frame.mapy.cz/s/hamegahodu" height="90%" width="100%" frameborder="0"></iframe>
      </div>

      <div class="sm:grid sm:grid-cols-2 sm:gap-2 lg:grid-cols-4 lg:gap-4">
        <div>
          <h4>Adresa</h4>
          <p>
            Poslův Mlýn - areál Termit<br>
            472 01 Doksy<br>
            Česká Republika
          </p>
        </div>

        <div>
          <h4>Kontakty</h4>
          <p>
            <a href="tel:++420776488764">+420 776 488 764</a><br>
            <a href="mailto:info@golfdoksy.cz">info@golfdoksy.cz</a><br>
            www.golfdoksy.cz
          </p>
        </div>

        <div>
          <h4>Sociální sítě</h4>
          <p>
            <a class="block" href="https://www.facebook.com/pages/Golf-Club-Doksy/179444881091">Facebook</a>
            <a class="block" href="https://twitter.com/GolfDoksy">Twitter</a>
            <a class="block" href="https://twitter.com/GolfDoksy">Instagram</a>
          </p>
        </div>

        <div>
          <h4>Lidé</h4>
          <p>
            <a class="block" href="mailto:martin.kuzel@golfdoksy.cz">Martin Kužel</a>
            <a class="block" href="mailto:zdenek.krenicky@golfdoksy.cz">Zdeněk Krenický</a>
            <a class="block" href="mailto:jiri.pokorny@golfdoksy.cz">Jiří Pokorný</a>
            <a class="block" href="mailto:pavel.bernardin@golfdoksy.cz">Pavel Bernardin</a>
            <a class="block" href="mailto:robert.smol@golfdoksy.cz">Robert Šmol</a>
          </p>
        </div>
      </div>
    </section>

  </main>

<footer class="relative mt-12"> 
    <img src="/images/footer.png" alt="Footer" class="absolute bottom-0">
  </footer>


<!-- 
  <div id="root" class="text-slate-900 antialiased">
    <div class="bg-gray-200 min-h-screen p-8 flex items-center justify-center">
      <PropertyCard :property="property"/>
    </div>

  </div> -->

</template>

<script>
// import PropertyCard from './components/PropertyCard.vue'
import NavBar from './components/NavBar.vue'

export default {
  name: 'App',
  components: {
    // PropertyCard,
    NavBar
  },
  data: () => ({
    property: {
      imageURL: "/images/propertyone.jpeg",
      imageAlt: "Rear view with modern architecture",
      beds: 3,
      baths: 2,
      title: "Modern home in city center",
      priceInCents: 190000,
      formatedPrice: "$1,900.00",
      reviewCount: 34,
      rating: 4,
    }
  })
}
</script>

<style>
#app {
  /* font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  margin-top: 60px; */
}
</style>
